import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noCategory: {
		id: 'native-issue-table.row.group-row.group-header.category-group-header.no-category',
		defaultMessage: 'Uncategorized',
		description: 'Label for grouped items without category',
	},
});
